import React from "react"
import {Button, ButtonProps} from "antd"
import cx from "classnames"
import styles from "./SecondaryButton.module.css"

type SecondaryButtonProps = ButtonProps & {
    bold?: boolean
    uppercase?: boolean
}

export function SecondaryButton(props: SecondaryButtonProps) {
    const {title, className, uppercase = true, bold = true, ...rest} = props

    return (
        <Button
            className={cx(styles.btn, className, {
                [styles.uppercase]: uppercase,
                [styles.bold]: bold
            })}
            {...rest}>
            {title}
            {props.children}
        </Button>
    )
}
